export const DashboardPage = () => (
  <div>
    <h1>DashboardPage works</h1>
  </div>
);
